/**
 * @author      david.loehr@zumper.com (David Loehr)
 * @copyright   Copyright (c) 2019, Zumper
 * @description isTruthy
 */

/**
 * @param {any} value foo
 * @returns {boolean} boolean
 */
export const isTruthy = <T>(
  value: T | null | undefined | 0 | false | ''
): value is T => {
  return !!value
}
